import type { APIInstance } from "./apiService";
import type { Physician } from "./physiciansService.types";
import type {
  InvitePhysicianPayload,
  ReinvitePhysicianPayload,
  ReinviteResponse,
  UpdatePhysicianPayload,
} from "./physiciansServiceV2.types";

export class PhysiciansServiceV2 {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async listPhysicians(firmId: string): Promise<Physician[]> {
    const response = await this.api.get<Physician[]>(`/firms/${firmId}/physicians`);
    return response.data;
  }

  async invitePhysician(firmId: string, payload: InvitePhysicianPayload): Promise<void> {
    await this.api.post(`/firms/${firmId}/users/physicians`, payload);
  }

  async reinvitePhysician(firmId: string, payload: ReinvitePhysicianPayload): Promise<string> {
    const response = await this.api.post<ReinviteResponse>(
      `/firms/${firmId}/users/physicians/reinvite`,
      payload
    );
    return response.data.message;
  }

  async updatePhysician(
    firmId: string,
    userId: string,
    payload: UpdatePhysicianPayload
  ): Promise<void> {
    await this.api.patch(`/firms/${firmId}/physicians/${userId}`, payload);
  }
}
